import { useInfiniteQuery } from 'react-query'
import { getAcceptedDemandLoans } from 'services/loans'

export default function useGetAcceptedDemandLoans(id: string | undefined) {
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['money-pools-fund-loans-accepted', id],
        ({ pageParam = 1, queryKey }) =>
            getAcceptedDemandLoans(pageParam, queryKey[1]),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        demandLoans: data,
        isLoadingDemandLoans: isLoading,
        refetch,
        fetchNextPage,
    }
}
